import React from 'react'

export default function index() {
    return (
        <div>
            Esta es Habilidades
        </div>
    )
}
